import { composeWithDevTools } from '@redux-devtools/extension';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import { reduxBatch } from '@manaflair/redux-batch';

import CommonDataListEventsReducer from '~shared/components/react/CommonDataListEvents/reducers/commonDataListEventsReducers';

const getCommonDataStore = () => {
    const composeEnhancers = composeWithDevTools({
        name: 'CommonDataListEvents Store',
    });

    return createStore(
        CommonDataListEventsReducer,
        {},
        composeEnhancers(
            applyMiddleware(thunk),
            reduxBatch
        )
    );
};

const commonDataStore = getCommonDataStore();

export default commonDataStore;
